import h from '../../../helpers/common';
import { getSelectedProfileAvatars } from '../../../helpers/profile';
import user from '../../../helpers/user';
import { isFreeOperator } from '@intigral/utils/lib/user';
import { menuTypes } from '../../../config/constants';
import { isGuestUser, isGuestVisibleMenuItem } from '../../../config/guestMode';

export const getProfileAvatar = (profile, avatarData) => {
    return getSelectedProfileAvatars(profile, avatarData);
};

export const selectProfileHandler = (e, clickedProfile, setClickedProfile) => {
    e.preventDefault();
    setClickedProfile(clickedProfile);
    h.setContext({ selectedProfile: { ...clickedProfile } });
};

const isControlKeysPressed = (e) => {
    return e.metaKey || e.shiftKey || e.ctrlKey || e.altKey;
};

export const handleSwitchLanguage = (e, language) => {
    if (isControlKeysPressed(e)) {
        return;
    }
    h.switchLang(language === 'en' ? 'ar' : 'en');
    const event = new Event('languageSwitched');
    document.dispatchEvent(event);
};

export const getFilteredGenericMenuItems = (items, operators, msisdnPrefix, screen = 'tvods') => {
    const userInfo = user.getUserInfo();
    let userOperator = (userInfo && 'operator' in userInfo && userInfo.operator) || '';
    userOperator = userOperator.toLowerCase();
    const operatorsList = Object.keys(operators || {}).reduce((acc, operator) => {
        acc[operator.toLowerCase()] = operators[operator];
        return acc;
    }, {});
    const userOperatorTVODConfig = operatorsList[userOperator]?.tvod;
    if (!userOperatorTVODConfig?.enable || !user.checkTVODUserMsisdnValidity(msisdnPrefix)) {
        items = items?.filter((item) => {
            return item?.screen !== screen;
        });
    }
    if (isGuestUser(userInfo)) {
        items = items?.filter((item) => isGuestVisibleMenuItem(item));
    }
    return items?.filter((item) => {
        return item.type !== menuTypes.USER;
    });
};
